import { AttachmentModel } from '../../content/recourse-booking/model/attachment.model';
import { RecourseBookingModel } from '../../content/recourse-booking/model/recourse-booking-model';
import { UploadFileModel } from '../../content/recourse-booking/model/upload-file-model';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { BookingStateEnum } from '../../shared/enums/booking-state-enum';
import { UserService } from '../user-service/user.service';

export function newAttachmentModel(
  userService: UserService,
  uploadFileModel: UploadFileModel,
  indexGenerator: any,
  dateFormatPipe: DateFormatPipe,
): AttachmentModel {
  const attachmentModel: AttachmentModel = new AttachmentModel();
  attachmentModel.createDate = dateFormatPipe.transformDateToGermanFormat(new Date());
  attachmentModel.creator = userService.getUser().ppnUserId;
  attachmentModel.filename = uploadFileModel.filename;
  attachmentModel.id = indexGenerator.next();
  attachmentModel.receiver = uploadFileModel.extern ? 'extern' : 'intern';
  attachmentModel.useridCreate = userService.getUser().ppnUserId;
  return attachmentModel;
}

export function createDeleteAttachmentAllowed(recourseBooking: RecourseBookingModel): boolean {
  switch (recourseBooking.bookingStateId) {
    case BookingStateEnum.IN_PROGRESS:
    case BookingStateEnum.IN_APPROVAL:
    case BookingStateEnum.APPROVED:
    case BookingStateEnum.REJECTED: {
      return true;
    }
    default: {
      return false;
    }
  }
}

export function bookingStatusUpdateNeeded(recourseBooking: RecourseBookingModel): boolean {
  switch (recourseBooking.bookingStateId) {
    case BookingStateEnum.IN_APPROVAL:
    case BookingStateEnum.APPROVED:
    case BookingStateEnum.REJECTED: {
      return true;
    }
    default: {
      return false;
    }
  }
}
